export const BLOG_IMAGE_ALT_MAP = {
  "https://backend.einsured.ca/wp-content/uploads/2026/01/Super-Visa-Insurance_-Complicated-Doesnt-Mean-Out-of-Reach-Featured-Image.png":
    "Super visa insurance",
  "https://backend.einsured.ca/wp-content/uploads/2026/01/Super-Visa-Insurance_-Complicated-Doesnt-Mean-Out-of-Reach.png":
    "Parent visitor coverage illustration",

  "https://backend.einsured.ca/wp-content/uploads/2026/01/Build-Wealth-in-2026-With-Whole-Life-Insurance-in-Canada.png":
    "Whole Life Insurance in Canada",
  "https://backend.einsured.ca/wp-content/uploads/2026/01/Whole-Life-Insurance-in-Canada.png":
    "Tax Benefits Whole life insurance",

  "https://backend.einsured.ca/wp-content/uploads/2025/12/chr.png":
    "Insurance for Children in Canada",
  "https://backend.einsured.ca/wp-content/uploads/2025/12/Insurance-for-Children-in-Canada-1.png":
    "Benefits of Children Insurance",

  "https://backend.einsured.ca/wp-content/uploads/2025/12/How-FHSA-Contributions-Reduce-Your-Taxes-and-Boost-Your-Down-Payment.png":
    "FHSA tax savings visual",
  "https://backend.einsured.ca/wp-content/uploads/2025/12/Universal-Life-Insurance-in-Canada.png":
    "FHSA Contributions Strategies",

  "https://backend.einsured.ca/wp-content/uploads/2025/11/5-Reasons-Why-Your-Super-Visa-Application-in-Brampton-Can-Be-Denied.png":
    "Super visa application in brampton",
  "https://backend.einsured.ca/wp-content/uploads/2025/11/Life-Insurance-At-a-Young-Age.png":
    "Points for super visa application",

  "https://backend.einsured.ca/wp-content/uploads/2025/11/2.png":
    "GEN-Z Critical Illness Insurance",
  "https://backend.einsured.ca/wp-content/uploads/2025/11/Options-for-Term-Life-Insurance.png":
    "Critical Illness Insurance Plan",

  "https://backend.einsured.ca/wp-content/uploads/2025/10/Super-Visa-Insurance-for-Parents-and-Grandparents_-Affordable-Long-Stay.png":
    "Insurance for parents and grand parents",
  "https://backend.einsured.ca/wp-content/uploads/2025/10/Super-Visa-Insurance-for-Parents-and-Grandparent.png":
    "Super visa insurance guide",

  "https://backend.einsured.ca/wp-content/uploads/2025/10/Key-Benefits-of-Term-Life-Insurance-for-Young-Families.png":
    "Benefits of term life Insurance",
  "https://backend.einsured.ca/wp-content/uploads/2025/10/Term-Life-Insurance.png":
    "Term life Insurance safeguard",

  "https://backend.einsured.ca/wp-content/uploads/2025/09/V1-Insurance-Canada-eiBlospost-RetirementLI-1200x400-AMS-12-Sep-2025-2-.png":
    "Life insurance retirement plan",
  "https://backend.einsured.ca/wp-content/uploads/2025/09/V1-Insurance-Canada-eiBlospost-RetirementLI-1200x400-AMS-12-Sep-2025-4-.png":
    "Investment Planning",

  "https://backend.einsured.ca/wp-content/uploads/2025/08/Insurance-Canada-eiBlogpostSV-mistakestoavoid-SC-1200x400px-8AUG2025-R1.png":
    "Super visa insurance in canada",
  "https://backend.einsured.ca/wp-content/uploads/2025/08/Insurance-Canada_ei-Blogpost-WL_1200x400px_SC_9-JULY-2025_V2.png":
    "Super Visa Insuranc Mistakes",

  "https://backend.einsured.ca/wp-content/uploads/2025/07/Insurance-Canada_ei-Blogpost-WL_1200x400px_SC_9-JULY-2025_V1.png":
    "Whole life insurance for financial planning",
  "https://backend.einsured.ca/wp-content/uploads/2025/07/Insurance-Canada_ei-Blogpost-WL_1200x400px_SC_9-JULY-2025_V2.png":
    "Whole Life Insurance Strategies",

  "https://backend.einsured.ca/wp-content/uploads/2025/07/Insurance-Canada-eiBlogpost-womeninsurance-1200X400-HB-01-JULY-2025-V2.jpg":
    "Prioritize life insurance",
  "https://backend.einsured.ca/wp-content/uploads/2025/07/Insurance-Canada-eiBlogpost-womeninsurance-1200X400-HB-02-JULY-2025-V1-infographic.jpg":
    "Women Empowement",

  "https://backend.einsured.ca/wp-content/uploads/2025/06/V1_Insurance-Canada_ei_-Super-visa-insurance-blogpost_1200X400_HB_12_MAY_2025_01.png":
    "Life Insurance for elderly in Brampton",
  "https://backend.einsured.ca/wp-content/uploads/2025/06/V1_Insurance-Canada_ei_-Super-visa-insurance-blogpost_1200X400_HB_12_MAY_2025_03.png":
    "Life Insurance Available for Seniors",

  "https://backend.einsured.ca/wp-content/uploads/2025/05/V1_Insurance-Canada_ei_-Super-visa-insurance-blogpost_1200X400_HB_12_MAY_2025_01.png":
    "Life Insurance can ease finanical Stress",
  "https://backend.einsured.ca/wp-content/uploads/2025/05/V1_Insurance-Canada_ei_-Super-visa-insurance-blogpost_1200X400_HB_12_MAY_2025_02.png":
    "Building Long-Term Savings Through Life Insurance",

  "https://backend.einsured.ca/wp-content/uploads/2025/05/Insurance-Canada-eiOccupationblogpost-1200X400-HB-06-MAY-2025-V1.png":
    "Right insurance based on occupation",

  "https://backend.einsured.ca/wp-content/uploads/2025/04/V1-Insurancecanada-eiBlogpostdisabilityinsurance-1200x400px-AA-22Apr2025-1.jpg":
    "Essential Disability Insurance",
  "https://backend.einsured.ca/wp-content/uploads/2025/04/V1-Insurancecanada-eiBlogpostdisabilityinsurance-1200x400px-AA-22Apr2025-3.jpg":
    "Disability Insurance Cover",

  "https://www.einsured.ca/wp-content/uploads/2025/04/Insurance-Canada-eiBlogpost-CI-2-1200x400px-TRK-01-April-2025-V2-1-1024x341.jpg":
    "Secure income now",

  "https://backend.einsured.ca/wp-content/uploads/2025/03/Insurance-Canada-eiCI-Blogpost-1200x400px-TRK-10-March-2025.jpg":
    "Critical illness insurance",
  "https://backend.einsured.ca/wp-content/uploads/2025/03/Insurance-Canada-eiCI-Blogpost-1200x400px-TRK-10-March-2025-Infographics-2.jpg":
    "Critical illness insurance coverage",

  "https://backend.einsured.ca/wp-content/uploads/2025/02/Insurance-Canada-eiBlogpost-Milestones-LI-1200x400px-TRK-21-Feb-2025-V1.jpg":
    "Insurance Protects Life",
  "https://backend.einsured.ca/wp-content/uploads/2025/02/Insurance-Canada-eiBlogpost-Milestones-LI-1200x400px-TRK-21-Feb-2025-V3.jpg":
    "family’s financial stability",

  "https://backend.einsured.ca/wp-content/uploads/2025/01/Insurance-Canada-eiBlogpost-CI-1200x400px-TRK-30-Jan-2025-1.jpg":
    "Spotlight Critical illness insurance",
  "https://backend.einsured.ca/wp-content/uploads/2025/01/Insurance-Canada-eiBlogpost-CI-1200x400px-TRK-30-Jan-2025-Infographics-1.jpg":
    "Critical Illness Insurance",

  "https://backend.einsured.ca/wp-content/uploads/2025/01/Insurancecanada-ei-Blogpost-millennial-1200x400px-AA-27Jan2025-V1.jpg":
    "Life Insurance for millennials",
  "https://backend.einsured.ca/wp-content/uploads/2025/01/Insurancecanada-ei-Blogpost-millennial-1200x400px-AA-29Jan2025-V1R1-2.jpg":
    "best life insurance policy",

  "https://backend.einsured.ca/wp-content/uploads/2025/01/Insurance-Canada-ei-Bloginfographics-supervisa-1200x400-HB-15Jan25-R1-V1.jpg":
    "Super Visa insurance canada",
  "https://backend.einsured.ca/wp-content/uploads/2025/01/Insurance-Canada-ei-Bloginfographics-supervisa-1200x400-HB-15Jan25-R1-V3.jpg":
    "Grandparents Super visa insurance",

  "https://backend.einsured.ca/wp-content/uploads/2024/12/Insurance-Canada-eiBlogpostLifeinsurance-1200x400px-TRK-23-Dec-2024-2.jpg":
    "Life Insurance Help Family achieve",
  "https://backend.einsured.ca/wp-content/uploads/2024/12/Insurance-Canada-eiBlogpostLifeinsurance-1200X400-HB-26-DEC-2024-V1.png":
    "term life insurance policy",

  "https://backend.einsured.ca/wp-content/uploads/2024/12/Insurancecanada-Blogposttopinsurancemistakes-1200x400px-AA-18Dec2024-V1-Design.jpg":
    "Insurance mistake",
  "https://backend.einsured.ca/wp-content/uploads/2024/12/Insurancecanada-Blogposttopinsurancemistakes-1200x400px-MB-20DEC2024-V1-R3.jpg":
    "Cheapest Policy Over the Best Value",

  "https://backend.einsured.ca/wp-content/uploads/2024/12/Insurancecanada-eiBlogpostTFSA-1200x400px-AA-12Dec2024-V1-Design.jpg":
    "TFSA Can Boost Your Savings",
  "https://backend.einsured.ca/wp-content/uploads/2024/12/Insurancecanada-eiBlogpostTFSA-1200x400px-AA-12Dec2024-V1-Infograohic.jpg":
    "Tax Free Savings Account",

  "https://backend.einsured.ca/wp-content/uploads/2024/12/Insurance-Canada-eiBlogpostRESP-1200x400px-TRK-05-Dec-2024-1.jpg":
    "RESP Plans",
  "https://backend.einsured.ca/wp-content/uploads/2024/12/Maximizing-RESP-Benefits-in-Canada-1.png":
    "RESP Benefits in Canada",

  "https://backend.einsured.ca/wp-content/uploads/2024/11/Insurance-Canada-ei-Blogpost-FHSA-1200x400px-SC-22-NOV-2024-Tax.jpg":
    "FHSA Tax Benefits",
  "https://backend.einsured.ca/wp-content/uploads/2024/11/Insurance-Canada-ei-Blogpost-FHSA-1200x400px-SC-22-NOV-2024-Infograph.jpg":
    "Faster Wealth Accumulation",

  "https://backend.einsured.ca/wp-content/uploads/2024/11/Insurancecanada-eiBlogpostRRSPandtaxes-1200x400px-AA-21Nov2024-V1-1.jpg":
    "RRSP in Canada",
  "https://backend.einsured.ca/wp-content/uploads/2024/11/Insurancecanada-eiBlogpostRRSPandtaxes-1200x400px-AA-21Nov2024-V1-2.jpg":
    "RRSP Help You Save on Taxes",

  "https://backend.einsured.ca/wp-content/uploads/2024/10/Insurance-Canada-eiBlogpost-Supervisainsurance-1200X400-AA-30Oct2024-V2-1.jpg":
    "Super Visa Insurance Requirements",
  "https://backend.einsured.ca/wp-content/uploads/2024/10/Insurance-Canada-eiBlogpost-Supervisainsurance-1200X400-AA-31Oct2024-V2R1-V3.jpg":
    "Super Visa medical insurance",

  "https://backend.einsured.ca/wp-content/uploads/2024/10/Insurance-Canada-eiBlogpostDisabilityinsurance-1200X400-TRK-15-Oct-2024-V1-R1.jpg":
    "Disability insurance quotes",
  "https://backend.einsured.ca/wp-content/uploads/2024/10/Insurance-Canada-eiBlogpostDisabilityinsurance-1200X400-HB-14-OCT-2024-V2.jpg":
    "Best Disability insurance quotes",

  "https://backend.einsured.ca/wp-content/uploads/2024/09/Insurance-Canada-eiBlogpostmortgageinsurance-1200x400px-24-sept-2024-03.jpg":
    "Private insurance vs banker's",
  "https://backend.einsured.ca/wp-content/uploads/2024/09/Insurance-Canada-eiBlogpostmortgageinsurance-1200x400px-24-sept-2024-02-v1.jpg":
    "Mortgage Insurance in Canada",

  "https://backend.einsured.ca/wp-content/uploads/2024/09/Insurancecanada-ei-Blogpost-WhyIt-sEssentialtoComparePricesandPolicies-1200x400px-TRK-05-Sept-2024-V1-R2-1.jpg":
    "Compare Prices and Policies",
  "https://backend.einsured.ca/wp-content/uploads/2024/09/Compare-Prices-and-Policies-from-Different-Insurance-Providers-Before-Buying-an-Insurance.png":
    "Policy Terms and Conditions",

  "https://backend.einsured.ca/wp-content/uploads/2024/08/Insurance-Canada-eiBlogpostHealthinsurance-1200X400-HB-21-AUG-2024-V1-01.jpg":
    "Healthcare insurance in canada",
  "https://backend.einsured.ca/wp-content/uploads/2024/08/Insurance-Canada-eiBlogpostHealthinsurance-1200X400-HB-21-AUG-2024-V1-02.jpg":
    "Types of Healthcare insurance in canada",

  "https://backend.einsured.ca/wp-content/uploads/2024/08/Insurance-Canada-eiBlogpostTraveladvisories-1200x400px-TRK-14-August-2024-V1.jpg":
    "Government Travel Advisories",
  "https://backend.einsured.ca/wp-content/uploads/2024/08/InsuranceCanada-eiBlogpostinfographicTraveladvisories-1200x400px-AA-14Aug2024-V1-1.jpg":
    "Travel Advisories",

  "https://backend.einsured.ca/wp-content/uploads/2024/08/Insurance-Canada-BlogpostSupervisa-1200x400-TRK-25-July-2024-V1-1.jpg":
    "Super Visa Applicants",
  "https://backend.einsured.ca/wp-content/uploads/2024/08/Super-Visa-application-process.png":
    "Super Visa Applications Process",

  "https://backend.einsured.ca/wp-content/uploads/2024/07/ei-Blogpost-criticalillnessinsurance-1200x400-DDA-11july2024-1.jpg":
    "Critical Illness  Insurance",
  "https://backend.einsured.ca/wp-content/uploads/2024/07/Critical-Life-Insurance.png":
    "Critical life insurance",

  "https://backend.einsured.ca/wp-content/uploads/2024/06/Insurance-Canada-eiCarouselUniversallifeinsurance-1200X400-HB-27-JUNE-2024-V1-R1-01.png":
    "Universal life insurance in canada",
  "https://backend.einsured.ca/wp-content/uploads/2024/06/Universal-Life-Insurance-in-Canada.png":
    "Benefits Universal life insurance",

  "https://backend.einsured.ca/wp-content/uploads/2024/06/Insurance-Canada-BlogpostYounginsurance-1200x400-HB-05-JUNE-24-V2-1.jpg":
    "Young Canadians life insurance",
  "https://backend.einsured.ca/wp-content/uploads/2024/06/Life-Insurance-At-a-Young-Age.png":
    "Life Insurance young age",

  "https://backend.einsured.ca/wp-content/uploads/2024/06/InsuranceCanada-eiBlogpostNomedicalinsurance-1200X400-HB-29-MAY-2024-V2-1.jpg":
    "Insurance for beginners",
  "https://backend.einsured.ca/wp-content/uploads/2024/06/No-Medical-Insurance-for-Beginners.png":
    "No Medical Insurance for Beginners",

  "https://backend.einsured.ca/wp-content/uploads/2024/05/Insurancecanada-eiBlogpostTravelinsuranceWeeklyplan-1200x400px-AA-15May2024-V1.jpg":
    "Travel Insurance for Canadian Adventure",
  "https://backend.einsured.ca/wp-content/uploads/2024/05/Tips-for-Finding-Affordable-Travel-Insurance-in-Canada.png":
    "Affordable Travel Insurance in Canada",

  "https://backend.einsured.ca/wp-content/uploads/2024/05/Insurance-Canada-eiBlogpostInternationalstudentplan-1200x400-VP-08May2024-V1-R1.jpg":
    "Private international medical insurance",
  "https://backend.einsured.ca/wp-content/uploads/2024/05/Medical-Insurance.png":
    "Choose Right insurance plan",

  "https://backend.einsured.ca/wp-content/uploads/2024/05/Insurance-Canada-ei-Blogpost-TheCompleteGuidetoWholeLifeInsuranceBenefitsinCanada-1200x400-VP-1May24-01.jpg":
    "Whole life insurance benefits in Canada",
  "https://backend.einsured.ca/wp-content/uploads/2024/05/Whole-Life-Insurance.png":
    "Importance of whole life insurance",

  "https://backend.einsured.ca/wp-content/uploads/2024/04/InsuranceCanada-blogpostCheapInsuranceSolutionsforSuperVisaApplicantsinCanada-1200x400-DB-8apr2024-v2-1.jpg":
    "Affordable Insurance Solutions",
  "https://backend.einsured.ca/wp-content/uploads/2024/04/Coverage-Options-for-Super-Visa-Insurance.png":
    "Coverage Options for Super Visa Insurance",

  "https://backend.einsured.ca/wp-content/uploads/2024/04/Insurance-Canada-eiBlogpostGuidetoVisitorInsuranceforInt-1.jpg":
    "Visitor insurance for parents and international student's",
  "https://backend.einsured.ca/wp-content/uploads/2024/04/Benefits-of-Visitor-Insurance.png":
    "Benefits of Visitor Insurance",

  "https://backend.einsured.ca/wp-content/uploads/2024/04/Insurance-Canada-ei-WeeklyPlan-HowReturnofPremiumEnhancesCriticalIllnessCoverage-1200x400-HB-03-APR-24-R1-01.jpg":
    "Premium Enhance Critical Illness coverage",
  "https://backend.einsured.ca/wp-content/uploads/2024/04/Critical-Illness-Policies.png":
    "Traditional Critical Illness Policies",

  "https://backend.einsured.ca/wp-content/uploads/2024/03/Insurance-Blogpostimage-1200x400-GK-20MAR2024-V1.jpg":
    "Whole life insurance choice for you",
  "https://backend.einsured.ca/wp-content/uploads/2024/03/Tips-for-Selecting-the-Right-Life-Insurance-Policy.png":
    "Right Life insurance policy",

  "https://backend.einsured.ca/wp-content/uploads/2024/03/Insurance-eilifeinsurance-ebook-600x200-GK-06FEB2024-V1.jpg":
    "Life insurance guide",
  "https://backend.einsured.ca/wp-content/uploads/2024/03/Types-of-life-insurance.png":
    "Types of life insurance",

  "https://backend.einsured.ca/wp-content/uploads/2024/02/Insurance-Canada-BlogpostUnlockTaxSavingsThePowerofYourRRSP-600X200-HB-27-FEB-2024-V1-1.jpg":
    "Tax Saving with RRSP",
  "https://backend.einsured.ca/wp-content/uploads/2024/02/A-Tax-Saving-Strategy-for-Couples.png":
    "Tax Saving strategy for couples",

  "https://backend.einsured.ca/wp-content/uploads/2024/02/blog-image.jpg":
    "Choose first insurance plan",
  "https://backend.einsured.ca/wp-content/uploads/2024/02/gLife-Insurance.jpg":
    "First Insurance plan wisely",

  "https://backend.einsured.ca/wp-content/uploads/2024/02/Insurance-Canada_ei-Blogpost-vtc-tool_600x200_VP_6Feb24_01.jpg":
    "Visitor to Canada emergency medical insurance",
  "https://backend.einsured.ca/wp-content/uploads/2024/02/Visitor-to-Canada.jpg":
    "Get Your free quote",

  "https://backend.einsured.ca/wp-content/uploads/2024/02/Insurance-Canada-BLOGPOST-600x200-AS-26JAN2024-V1-1-1.jpg":
    "International students financial roadmap",
  "https://backend.einsured.ca/wp-content/uploads/2024/02/Student-Visa.png":
    "International students roadmap",

  "https://backend.einsured.ca/wp-content/uploads/2024/01/Insurance-Canada-ei-Blogpost-Whyislifeinsuranceimportantforsingleparents-600x200-VP-17Jan24-1.jpg":
    "Single Parents life insurance",
  "https://backend.einsured.ca/wp-content/uploads/2024/01/jOptions-for-Term-Life-Insurance-1.jpg":
    "Choose right types of insurance",

  "https://backend.einsured.ca/wp-content/uploads/2024/01/EIINSURANCE-BLOG-POST-OPENFILE-1024x300-AS-3JAN2024-V1.jpg":
    "Term life insurance expiring",
  "https://backend.einsured.ca/wp-content/uploads/2024/01/Options-for-Term-Life-Insurance.png":
    "Term life insurance options",

  "https://backend.einsured.ca/wp-content/uploads/2023/12/Insurance-Canada-ei-WeeklyBlogPost-MandatorySuperVisa-600x200-VP-5Dec23-1.png":
    "Active super visa insurance",

  "https://backend.einsured.ca/wp-content/uploads/2023/11/Insurance-Canada-eiBlogpost-VTCInsurance-1200x630-VP-28Nov23.jpg":
    "Visitor insurance",
  "https://backend.einsured.ca/wp-content/uploads/2023/11/LLIFE-CHANGING-STORY-OF-RAJ.jpg":
    "Life changing story of raj",

  "https://backend.einsured.ca/wp-content/uploads/2023/11/New-Project-8.jpg":
    "First Home Savings Account",
  "https://backend.einsured.ca/wp-content/uploads/2023/11/home-loan.png":
    "Home Savings Account",

  "https://backend.einsured.ca/wp-content/uploads/2023/11/New-Project-7.jpg":
    "Life Insurance Advisor",
  "https://backend.einsured.ca/wp-content/uploads/2023/11/Your-Trusted-Insurance-Advisor.png":
    "Your Trusted Insurance advisor",

  "https://backend.einsured.ca/wp-content/uploads/2023/10/New-Project-1.jpg":
    "Hundreds of super visa clients",
  "https://backend.einsured.ca/wp-content/uploads/2023/10/ei_-Maria-story-5-things-super-visa-blog-post.png":
    "Super Visa Clients",

  "https://backend.einsured.ca/wp-content/uploads/2023/09/Insurance-Canada-Blogposts-1200x400-TRK-9JULY2024-V2-1.jpg":
    "Insurance types works for you",
  "https://backend.einsured.ca/wp-content/uploads/2023/09/Life-Insurance-for-Youngsters.png":
    "Life Insurance for Youngsters",

  "https://backend.einsured.ca/wp-content/uploads/2023/03/Insurance-Canada-Blogposts-1200x400-TK-14JUNE2024-V16.jpg":
    "Education savings plan in canada",
  "https://backend.einsured.ca/wp-content/uploads/2023/10/Choose-a-Suitable-Plan-for-RESP.png":
    "Suitable Plan for RESP",

  "https://backend.einsured.ca/wp-content/uploads/2023/03/Insurance-Canada-Blogposts-1200x400-TK-14JUNE2024-V14.jpg":
    "Difference Mortgage vs Life Insurance",
  "https://backend.einsured.ca/wp-content/uploads/2023/06/Mortgage-Insurance-vs.-Life-Insurance.png":
    "Mortgage Insurance vs Life Insurance",

  "https://backend.einsured.ca/wp-content/uploads/2023/06/Insurance-Canada-Blogposts-1200x400-TRK-9JULY2024-V6-1.jpg":
    "Term Life Insurance in Canada",
  "https://backend.einsured.ca/wp-content/uploads/2023/06/Term-Life-Insurance.png":
    "Benefits of Term life insurance",

  "https://backend.einsured.ca/wp-content/uploads/2023/03/Insurance-Canada-Blogposts-1200x400-TK-14JUNE2024-V12.jpg":
    "Mortgage Insurance vs Disability Insurance",
  "https://backend.einsured.ca/wp-content/uploads/2023/06/Difference-Between-Mortgage-Disability-Insurance.png":
    "Difference Between Mortgage Disability Insurance",

  "https://backend.einsured.ca/wp-content/uploads/2023/03/Insurance-Canada-Blogposts-1200x400-TK-14JUNE2024-V11.jpg":
    "Super visa emergency medical insurance",
  "https://backend.einsured.ca/wp-content/uploads/2023/03/What-are-the-Advantages-of-Super-Visa-Insurance.png":
    "Advantages of Super Visa Insurance",

  "https://backend.einsured.ca/wp-content/uploads/2023/03/Insurance-Canada-Blogposts-1200x400-TRK-9JULY2024-V10-1.jpg":
    "Term Life insurance is expiring",
  "https://backend.einsured.ca/wp-content/uploads/2023/03/Options-When-Your-Term-Policy-Nears-Expiry.png":
    "Term Policy Nears Expiry",

  "https://backend.einsured.ca/wp-content/uploads/2022/12/Insurance-Canada-Blogposts-1200x400-TRK-9JULY2024-V9-1.jpg":
    "key terms on insurance policy",
  "https://backend.einsured.ca/wp-content/uploads/2022/12/How-to-Buy-Your-Insurance-Policy_.png":
    "Buy your insurance policy",

  "https://backend.einsured.ca/wp-content/uploads/2022/12/Insurance-Canada-Blogposts-1200x400-AS-11JUNE2024-V8.jpg":
    "Guide to buy life insurance",

  "https://backend.einsured.ca/wp-content/uploads/2022/12/Insurance-Canada-Blogposts-1200x400-AS-11JUNE2024-V7.jpg":
    "Compare life insurance",
  "https://backend.einsured.ca/wp-content/uploads/2022/12/Get-The-Right-Insurance-Plan-for-Your-Family.png":
    "Right Insurance plan for your family",

  "https://backend.einsured.ca/wp-content/uploads/2022/12/Insurance-Canada-Blogposts-1200x400-AS-11JUNE2024-V6.jpg":
    "Life insurance 101",
  "https://backend.einsured.ca/wp-content/uploads/2022/12/Understanding-the-Basics-of-Life-insurance-.png":
    "Basics of Life insurance",

  "https://backend.einsured.ca/wp-content/uploads/2022/12/Insurance-Canada-Blogposts-1200x400-AS-11JUNE2024-V5.jpg":
    "Super visa insurance and its cost",
  "https://backend.einsured.ca/wp-content/uploads/2022/12/Super-Visa-insurance-Cost.png":
    "Super visa insurance cost",

  "https://backend.einsured.ca/wp-content/uploads/2022/12/Insurance-Canada-Blogposts-1200x400-AS-11JUNE2024-V4.jpg":
    "Significance of Disability Insurance",
  "https://backend.einsured.ca/wp-content/uploads/2022/12/Disability-Insurance.png":
    "Disability Insurance",

  "https://backend.einsured.ca/wp-content/uploads/2022/12/Permanent-Life-Insurance.png":
    "Permanent Life Insurance",
  "https://backend.einsured.ca/wp-content/uploads/2022/12/Permanent-Term-Life-Insurance.png":
    "Permanent & Term Life Insurance",

  "https://backend.einsured.ca/wp-content/uploads/2022/12/Insurance-Canada-Blogposts-1200x400-AS-11JUNE2024-V3.jpg":
    "Tips to buy life insurance online",
  "https://backend.einsured.ca/wp-content/uploads/2022/12/Tips-to-Buy-Life-Insurance-Online-the-Smart-Way-.png":
    "Buy life insurance online",

  "https://backend.einsured.ca/wp-content/uploads/2022/12/Insurance-Canada-Blogposts-1200x400-AS-11JUNE2024-V2.jpg":
    "Super Visa insurance monthly installment",
  "https://backend.einsured.ca/wp-content/uploads/2022/12/Not-able-to-pay-for-Super-Visa-Insurance-in-full.png":
    "Not able to pay for Super Visa Insurance in full",

  "https://backend.einsured.ca/wp-content/uploads/2022/12/Insurance-Canada-Blogposts-1200x400-AS-11JUNE2024-V1.jpg":
    "Ultimate super visa checklist",
  "https://backend.einsured.ca/wp-content/uploads/2022/12/The-Ultimate-Super-Visa-Checklist.png":
    "Insurance policy in brampton",

  "https://backend.einsured.ca/wp-content/uploads/2022/12/Life-Insurance-Policy-in-Brampton.png":
    "Factor Influencing your life insurance",
  "https://backend.einsured.ca/wp-content/uploads/2022/12/Things-You-Should-Know-Before-Buying-Life-Insurance-Policy-in-Brampton-1.png":
    "Buying life insurance policy in brampton",

  "https://www.einsured.ca/assets/img81-CFZm-qCE.jpg":
    "Emergency medical insurance",
};